import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  showLoading() {
    const grid = document.getElementById("listings-grid")
    if (grid) grid.classList.add("opacity-60", "transition-opacity", "duration-300", "pointer-events-none")
  }

  hideLoading() {
    const grid = document.getElementById("listings-grid")
    if (grid) grid.classList.remove("opacity-60", "pointer-events-none")
  }
}
